export default __webpack_public_path__ + "static/blob4-db6f80a6c481f1c7c4e5a5c64a3ee2dd.svg";